<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-08 09:55:07
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:49:34
 * @name: 内容
 * @Description: 内容
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\Content.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="content">
    <div class="titlebox" v-if="title">
      <font class="title">{{ title }}</font>
      <el-button
        size="mini"
        plain
        round
        v-if="mailList.treeNode.level > 1"
        @click="edit"
      >
        编辑
      </el-button>
      <el-button size="mini" plain round @click="add">{{mailList.treeNode.level > 1 ? '添加子部门' : '添加部门'}}</el-button>
    </div>
    <div class="titlebox" v-else>
      <el-button size="mini" plain round @click="add">添加部门</el-button>
    </div>
    <!-- <children-list :mailList="mailList" class="childrenList"></children-list> -->
    <wait-approve :mailList="mailList" v-if="title && mailList.treeNode.level === 1"></wait-approve>
    <people-table
      :mailList="mailList"
      v-if="title && mailList.treeNode.level > 1"
    ></people-table>
    <edit-department :mailList="mailList" ref="edit"></edit-department>
    <add-department :mailList="mailList" ref="add"></add-department>
  </div>
</template>
<script>
import childrenList from "./children-list.vue";
import waitApprove from "./wait-approve.vue";
import peopleTable from "./people-table.vue";
import editDepartment from "./dialog/edit-department.vue";
import addDepartment from "./dialog/add-department.vue";
import { debounceation } from "@/utils/decorator";
export default {
  name: "mailList-Content",
  components: {
    childrenList,
    waitApprove,
    peopleTable,
    editDepartment,
    addDepartment,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  computed: {
    title() {
      return this.mailList.treeNode.department_name;
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击编辑
     */
    @debounceation(300)
    edit() {
      this.$refs.edit.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击添加子部门
     */
    @debounceation(300)
    add() {
      this.$refs.add.open();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: calc(100% - 300px);
  box-sizing: border-box;
  @extend .extend-content;
  @extend .extend-flex-column-normal;
  .titlebox {
    @extend .extend-titlebox;
  }
}
</style>